import type { Client } from '@peloton/api/utils';
import { pipeData } from '@peloton/api/utils';
import { ME } from '@engage/members/models';

const toProfileUrl = (id: string) => (id === ME ? `api/me` : `api/user/${id}`);

export const fetchMember = (api: Client, id: string): Promise<FetchedMember> =>
  api.get(toProfileUrl(id)).then(pipeData(x => x));

type FetchedMember = any;
